<template>
  <v-dialog v-model="dialog" persistent max-width="950px">
    <v-card>
      <div class="dialog-header">
          <h3 class="popup-title">영상회의실 선택</h3>
          <div class="header-btn" style="margin-right: 30px;">
          </div>
        </div>
      <div class="popup_contents" style="align-items: start; padding-top: 20px; min-height: 450px">
        <div style="width: 45%;">
          <div class="pop-con-header">
            <div>조회 목록</div>
            <div style="cursor: pointer;" class="all-selected-btn" @click="selectAll()">전체 선택</div>
          </div>
          
          <div style="border: 1px solid #e9e9e9; height: 450px; border-radius: 5px; display: flex; flex-direction: column; font-size: 17px; padding: 15px; overflow: auto; margin-top: 5px; font-weight: 300;">
            <div v-for="sc in codecList" :key="sc._id" style="padding-bottom: 4px;">
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  v-model="checkedVideoRoom"
                  
                  :value="sc"
                />
                <span class="checkmark"></span>
                {{ sc.eqpmt_nm }}

              </label>
            </div>
          </div>
        </div>
        <div style="display: flex; height: 100%; justify-content: center; align-items: center; min-height: 450px;">
          <button @click="addConferenceRoom" class="organization_add_btn">
            추가
          </button>
        </div>
        <div style="width: 45%;">
          <div class="pop-con-header">
            <div>선택 목록</div>
            <div style="cursor: pointer;" class="all-delete-btn" @click="deleteAll()">전체 삭제</div>
          </div>
          <div style="border: 1px solid #e9e9e9; height: 450px; border-radius: 5px; display: flex; flex-direction: column; font-size: 17px; padding: 15px; overflow: auto; margin-top: 5px; font-weight: 300;">
            <div v-for="sc in selectedVideoRoom" :key="sc._id" style="padding-bottom: 4px; display: flex; align-items: center; justify-content: space-between;">
              <div>{{ sc.eqpmt_nm ? sc.eqpmt_nm : sc.deviceName }}</div>
              <img src="/static/icon-contents/close-1.svg" style="width: 12px; cursor:pointer; margin-left: 10px;" @click="deleteRoom(sc)">
            </div>
          </div>
        </div>
      </div>
      <div class="btnArea">
        <button class="close-btn" @click="closeMeetingConference()">
          닫기
        </button>
        <button class="invite-btn" @click="selectionComplete">
          완료
        </button>
      </div>
      <!-- <div class="popup_tel_wrap">
        <div class="seltabwrap">
          <div class="conf-dialog-contents">
            <div v-if="schList.length !== 0">
              <div class="dialog-subtitle">회의실 목록</div>
              <div class="conf-list" v-for="sc in schList" :key="sc.brdId">
                <input
                  type="checkbox"
                  v-model="selectedVideoRoom"
                  :id="sc.brdId"
                  :value="sc"
                />
                <label :for="sc._id" :id="sc._id">
                  {{ sc.deviceName }}
                </label>
              </div>
            </div>
            <div
              v-else-if="schList.length === 0 && codecList.length === 0"
              style="margin: 20px; font-size: 16px; color: #604af3;"
            >
              예약이 가능한 영상회의실이 없습니다.
            </div>
            <div v-if="codecList.length !== 0" style="margin-top: 20px;">
              <div class="dialog-subtitle">예약이 가능한 회의실 목록</div>
              <div class="conf-list" v-for="sc in codecList" :key="sc.brdId">
                <input
                  type="checkbox"
                  v-model="selectedVideoRoom"
                  :id="sc._id"
                  :value="sc"
                  :disabled="meetingInfo.meetingType === 'conf'"
                />
                <label :for="sc._id" :id="sc._id">
                  {{ sc.deviceName }}
                </label>
              </div>
            </div>
          </div>
          <div class="btnArea">
            <button class="close-btn" @click="closeMeetingConference()">
              닫기
            </button>
            <button class="invite-btn" @click="selectionComplete">
              완료
            </button>
          </div>
        </div>
      </div> -->
    </v-card>
  </v-dialog>
</template>
<script>
import Util from "@/util";

import MeetingCreate from "@/components/meeting/MeetingCreate";
import moment from "moment";

export default {
  components: {
    MeetingCreate,
  },
  props: ["dialog", "conferenceRooms", "closeDialog", "meetingInfo"],
  data () {
    return {
      buildingList: [],
      checkedSch: [],
      isHelpActive: "none",
      roomItems: [],
      roomTree: [],
      roomActive: [],
      clickedRoom: null,
      checkedVideoRoom: [],
      selectedVideoRoom: [],
      selectedConferenceRooms: [],
      schList: [],
      codecList: [],
    };
  },
  watch: {
    dialog: {
      handler(val) {
        if (val) {
          this.init();
        }
      },
    },
  },
  methods: {
    async init () {
      this.buildingList = [];
      let params = {
        userID: this.$store.state.user.empNum,
        startDate: moment(this.meetingInfo.startDtime).format('YYYYMMDD'),
        startTime: moment(this.meetingInfo.startDtime).utc().format('HHmm'),
        endDate: moment(this.meetingInfo.endDtime).format('YYYYMMDD'),
        endTime: moment(this.meetingInfo.endDtime).utc().format('HHmm')
      };
      await this.$http
        .post("/api/v1/meetings/ksd/conferenceRooms", params)
        .then(response => {
          this.codecList = response.data;
          
          if (this.conferenceRooms.length !== 0) {
            this.selectedVideoRoom = this.conferenceRooms;
          } else if (this.conferenceRooms.length === 0) {
            this.selectedVideoRoom = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async showConferenceRooms (company) {
      
      let params = {
        companyId: company._id,
      };
      this.roomTree = [];
      this.roomItems = [];
      await this.$http
        .get("/api/v1/rooms/treeAll", { params: params })
        .then(response => {
          if (response) {
            let data = response.data;
            this.roomItems.push(data);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openTeamMember (team) {
      /* 회의실 클릭 */
      console.log(team);
      if (
        team.hasOwnProperty("companyId") === true &&
        team.hasOwnProperty("buildingId") === true
      ) {
        this.clickedRoom = team;
        console.log("방");
      } else if (team.hasOwnProperty("companyId")) {
        console.log("빌딩");
      } else {
        console.log("회사");
      }
    },
    selectedRoomNode (item) {
      this.roomTree = item;
    },
    addConferenceRoom () {
      const idSet = new Set(this.selectedVideoRoom.map(item => item.cuse_eqpmt_seq));

      this.checkedVideoRoom.forEach(item => {
        if (!idSet.has(item.cuse_eqpmt_seq)) {
          this.selectedVideoRoom.push(item);
          idSet.add(item.cuse_eqpmt_seq);
        }
      });
      this.checkedVideoRoom = [];
    },
    deleteRoom (room) {
      console.log(`room` , room)

      if (room.sn) {
        // 수정 시
        let selectedVideoRoom = this.selectedVideoRoom;
        for (let i = 0; i < selectedVideoRoom.length; i++) {
          if (room.sn.toString() === selectedVideoRoom[i].sn.toString()) {
            selectedVideoRoom.splice(i, 1);
          }
        }
      } else {
        // 개설 시
        let selectedVideoRoom = this.selectedVideoRoom;
        for (let i = 0; i < selectedVideoRoom.length; i++) {
          if (room.cuse_eqpmt_seq.toString() === selectedVideoRoom[i].cuse_eqpmt_seq.toString()) {
            selectedVideoRoom.splice(i, 1);
          }
        }
      }
    },
    deleteAllConferenceRooms () {
      /* 전체삭제  */
      this.selectedVideoRoom = [];
    },
    selectionComplete () {
      /* 선택완료하면 MeetingCreateDialog로 회의실 값 넘겨줌 */
      this.$emit("selectedConferenceRooms", this.selectedVideoRoom);
      this.closeDialog();
    },
    closeMeetingConference () {
      if (this.conferenceRooms.length === 0) {
        this.selectedVideoRoom = [];
      }
      this.closeDialog();
    },
    openHelpDialog () {
      this.isHelpActive = '';
    },
    closeHelpDialog () {
      this.isHelpActive = 'none';
    },
    async changeConf (conf) { 
      this.buildingList.map(el => el.active = false);
      conf.active = true;

      let params = {
        buildingId: conf._id,
      };

      await this.$http
        .get("/api/v1/devices", { params: params })
        .then(response => {
          this.codecList = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectAll () {
      if (this.checkedVideoRoom.length !== 0) {
        this.checkedVideoRoom = [];
      } else {
        this.checkedVideoRoom = [...this.codecList];
      }
    },
    deleteAll () {
      this.selectedVideoRoom = [];
    },
    getUnique (arr, comp) {
      const unique = arr
        .map(e => e[comp])
        // store the keys of the unique objects
        .map((e, i, final) => final.indexOf(e) === i && i)
        // eliminate the dead keys & store unique objects
        .filter(e => arr[e])
        .map(e => arr[e]);
      return unique;
    },
  },
};
</script>
<style scoped>
.dialog-subtitle {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: -0.04em;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
}

.dialog-hrLine {
  border-bottom: 1px solid #333;
  padding-left: 30px;
}
li > a {
  color: #464646;
}
.selta_l {
  width: 250px;
  height: 380px;
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px 10px 10px 10px;
  float: left;
  margin: 3%;
}

.seltabwrap {
  width: 92%;
  margin: 0 auto;
  margin-top: 20px;
}
.seltab {
  width: 8%;
  text-align: center;
  margin-top: 19%;
  float: left;
}
.seltab_r {
  width: 37%;
  border: 1px solid #ddd;
  border-radius: 5px;
  position: relative;
  height: 380px;
  padding: 10px;
  float: left;
  margin: 3%;
}

.seltab_r .tbwscroll {
  width: 100%;
  height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
}
.tbw_top_left {
  height: 40px;
  line-height: 30px;
}

.seltab .btn_com {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  padding: 0;
}

.del-all-btn {
  float: right;
  margin-right: 10px;
  width: 50px;
  height: 26px;
  line-height: 26px;
  font-size: 11px;
  font-weight: 300;
  background: #fff;
  color: #1457aa;
  border-radius: 5px;
  border: 1px solid #1457aa;
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
}

.seltab_r .scroll_tit li {
  float: left;
  height: 33px;
  text-align: center;
  border-top: 2px solid #1457aa;
  border-bottom: 1px solid #1457aa;
  line-height: 33px;
  color: black;
  padding: 0;
}

.seltabwrap {
  margin-top: 10px;
}
/* 검색바 */
.seltabwrap .searchbox {
  float: left;
  width: 22%;
}
.seltabwrap .search_top {
  width: 100%;
}
.seltabwrap .search_top .search_input {
  width: 100%;
  padding: 0;
}
.seltabcontent {
  clear: both;
  font-size: 13px;
}

.organization-list-item {
  cursor: pointer;
  font-size: 13px;
  color: #464646;
}

/* 회의실 스크롤 바 */
.organization-wrap::-webkit-scrollbar {
  width: 10px;
  cursor: pointer;
}
.organization-wrap::-webkit-scrollbar-track {
  background-color: transparent;
}
.organization-wrap::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.organization-wrap::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}

/* 선택된 회의실 리스트 스크롤 바 */
.mCustomScrollbar::-webkit-scrollbar {
  width: 10px;
  cursor: pointer;
}
.mCustomScrollbar::-webkit-scrollbar-track {
  background-color: transparent;
}
.mCustomScrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.mCustomScrollbar::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}

/* 선택된 회의실 리스트 CSS */
.seltab_r .scroll_tit li:nth-child(1) {
  width: 33%;
}
.seltab_r .scroll_tit li:nth-child(2) {
  width: 29%;
}
.seltab_r .scroll_tit li:nth-child(3) {
  width: 22%;
}
.seltab_r .scroll_tit li:nth-child(4) {
  width: 15%;
}

.theme--light.v-treeview .v-treeview-node--active .organization-list-item {
  color: red;
}

.seltab_r .btn_del {
  width: 27px;
  height: 27px;
  position: relative;
  background: url(/static/webex-cloud/images/common/pop_ico.png) 0px -58px;
  background-repeat: no-repeat;
}

.help-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow-y: auto;
  overflow-x: auto;
  text-align: center;
}
.help-img {
  width: 100%;
  max-width: 680px;
  display: inline-block;
  position: relative;
  top: 7%;
}

.close-img {
  position: fixed;
  top: 10%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}
.layout-close-btn {
  padding: 4px 13px;
  border: none;
  border-radius: 5px;
  background: #1757a1;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  letter-spacing: -1px;
  margin-left: 0;
}

.popup_top {
  padding-left: 0;
  background-color: #efeefd;
}

.btnArea {
  clear: both;
  display: flex;
  justify-content: end;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 82px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}

.conf-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px;
}

.conf-list input {
  width: 16px;
  margin-right: 10px;
}

.conf-list label {
  font-size: 16px;
}

.activeConf {
  background-color: #604af3;
  color: white;
  border-radius: 5px;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  margin-bottom: 5px;
  position: relative;
}

.custom-checkbox input[type="checkbox"] {
  display:none;
}

.checkmark{
  width: 18px;
  height:18px;
  border: 1px solid #c9c9c9;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #604af3;
}

.pop-con-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.all-selected-btn {
  border-radius: 4px;
  border: 1px solid #604af3;
  background: #fff;
  color: #604af3;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.28px;
  padding: 3px;
}

.all-delete-btn {
  border-radius: 4px;
  border: 1px solid #971118;
  background: #fff;
  color: #971118;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.28px;
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MeetingConferenceDialog.vue